
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useTranslation from "next-translate/useTranslation";
import SignWith from "../components/Auth/SignWith";
import AuthBackground from "../components/ReuseableCompos/AuthBackground";
import SEO from "components/Seo";
import { useRouter } from "next/router";
import { useEffect } from "react";
import SignInForm from "../components/ReuseableCompos/AuthModal/SignInForm";
import { useAuthContext } from "../context/AuthContext";
const Login = () => {
    const { t } = useTranslation("common");
    const { donor } = useAuthContext();
    const router = useRouter();
    useEffect(() => {
        if (donor) {
            if (router.query.return_url) {
                const return_url = Array.isArray(router.query.return_url)
                    ? router.query.return_url[0]
                    : router.query.return_url;
                router.replace(return_url);
            }
            else {
                router.replace("/");
            }
        }
    }, [donor, router]);
    return (<>
      <SEO title={t("login")} description={t("login")}/>
      <AuthBackground />
      <section className="container d-flex align-items-center pt-7 pb-3 pb-md-4" style={{ flex: "1 0 auto" }}>
        <div className="w-100 pt-3">
          <div className="row">
            <div className="col-lg-4 col-md-6 offset-lg-1">
              <div className="view show" id="signin-view">
                <h1 className="h2 text-center">{t(`login`)}</h1>

                <div className="mb-4">
                  <SignWith />
                </div>

                <SignInForm fromPage/>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>);
};
export default Login;

    async function __Next_Translate__getStaticProps__1a13f66bdc8__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/login',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13f66bdc8__ as getStaticProps }
  